// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"q_w","Container":"q_k"};